import { Outlet } from "react-router-dom"





const Products = () => {

    return (
        <div>
            <Outlet />
        </div>
    )
}

export default Products;